<template>
  <div class="room-type-page" :class="{ 'room-type-page--mobile': ebkMobile }">
    <page-breadcrumb :items="pageBreadcrumbItems" :mobile="ebkMobile" />
    <el-card class="box-card room-hotel-card" :body-style="bodyStyle" data-ebk-guide="room-hotel-card">
      <div slot="header" class="room-hotel-card__hd">
        <span class="room-hotel-card__name">{{ chooseHotel.res_name }}</span>
        <el-tag
          v-if="hotelUpStatusText"
          size="small"
          :type="hotelUpTagType"
          effect="plain"
          class="room-hotel-card__tag"
        >{{ hotelUpStatusText }}</el-tag>
      </div>
      <!-- 移动端：2 列摘要 + 地址/备注/介绍分块 -->
      <div v-if="ebkMobile" class="room-hotel-m">
        <div class="room-hotel-m__facts">
          <div
            v-for="row in hotelInfoMobileFactRows"
            :key="'m-f-' + row.key"
            class="room-hotel-m__fact"
          >
            <div class="room-hotel-m__fact-k">{{ row.label }}</div>
            <a
              v-if="row.key === 'phone' && row.value !== '—'"
              class="room-hotel-m__fact-v room-hotel-m__fact-v--tel"
              :href="'tel:' + row.value"
            >{{ row.value }}</a>
            <div v-else class="room-hotel-m__fact-v">{{ row.value }}</div>
          </div>
        </div>
        <div class="room-hotel-m__sect">
          <div class="room-hotel-m__sect-k">
            <i class="el-icon-location"></i>酒店地址
          </div>
          <div class="room-hotel-m__sect-v">{{ hotelAddressText }}</div>
        </div>
        <div class="room-hotel-m__sect">
          <div class="room-hotel-m__sect-k">
            <i class="el-icon-edit-outline"></i>酒店备注
          </div>
          <el-input
            class="room-hotel-m__input"
            placeholder="暂无备注"
            size="small"
            :readonly="!canMaintainHotel"
            @blur="edidRemarks"
            v-model="chooseHotel.rb_deposit_and_prepaid"
            clearable
          />
        </div>
        <div class="room-hotel-m__sect room-hotel-m__sect--last">
          <div class="room-hotel-m__sect-k">
            <i class="el-icon-chat-dot-round"></i>酒店介绍
          </div>
          <div
            class="room-hotel-intro room-hotel-intro--html room-hotel-m__intro"
            v-html="hotelIntroHtml"
          ></div>
        </div>
      </div>
      <!-- 桌面端：横向标签 + 网格，介绍/地址独占一行 -->
      <div v-else class="room-hotel-desk">
        <div class="room-hotel-desk__grid">
          <div
            v-for="row in hotelInfoBasicRows"
            :key="'d-h-' + row.key"
            class="room-hotel-desk__item"
          >
            <div class="room-hotel-desk__label">
              <i v-if="row.icon" :class="row.icon"></i>{{ row.label }}
            </div>
            <div class="room-hotel-desk__value">{{ row.value }}</div>
          </div>
          <div class="room-hotel-desk__item room-hotel-desk__item--full">
            <div class="room-hotel-desk__label">
              <i class="el-icon-location"></i>酒店地址
            </div>
            <div class="room-hotel-desk__value">{{ hotelAddressText }}</div>
          </div>
          <div class="room-hotel-desk__item room-hotel-desk__item--full">
            <div class="room-hotel-desk__label">
              <i class="el-icon-edit-outline"></i>酒店备注
            </div>
            <div class="room-hotel-desk__value">
              <el-input
                placeholder="暂无备注"
                size="small"
                :readonly="!canMaintainHotel"
                @blur="edidRemarks"
                v-model="chooseHotel.rb_deposit_and_prepaid"
                clearable
              />
            </div>
          </div>
          <div class="room-hotel-desk__item room-hotel-desk__item--full room-hotel-desk__item--intro">
            <div class="room-hotel-desk__label">
              <i class="el-icon-chat-dot-round"></i>酒店介绍
            </div>
            <div
              class="room-hotel-desk__value room-hotel-intro room-hotel-intro--html"
              v-html="hotelIntroHtml"
            ></div>
          </div>
        </div>
      </div>
    </el-card>

    <div v-show="!ebkMobile" class="ta-r mt-3 row jc-sb ai-c wrap" data-ebk-guide="room-policy-toolbar">
      <div class="fb fc-m ml-2">房型政策</div>
      <div class="row ai-c wrap room-policy-actions-desk">
        <el-date-picker v-model="rs_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions0"
          size="small" placeholder="选择日期">
        </el-date-picker>
        <el-select class="hundred ml-2" v-model="days" clearable size="small" placeholder="请选择">
          <el-option label="按周" value="7"></el-option>
          <el-option label="按月" :value="monthDays"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="HotelDetail" class="ml-2" size="small">查询政策</el-button>
        <el-button type="primary" icon="el-icon-plus" :disabled="!canMaintainHotel" data-ebk-guide="room-add-type" @click="proShowBaseList" size="small" class="ml-2">新增房型</el-button>
      </div>
    </div>
    <div v-show="ebkMobile" class="room-m-policy mt-3" data-ebk-guide="room-policy-toolbar">
      <div class="room-m-section-title">房型政策</div>
      <div class="room-m-policy-fields">
        <el-date-picker
          v-model="rs_time"
          class="room-m-control"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions0"
          size="small"
          placeholder="选择日期"
        />
        <el-select class="room-m-control" v-model="days" clearable size="small" placeholder="周期">
          <el-option label="按周" value="7"></el-option>
          <el-option label="按月" :value="monthDays"></el-option>
        </el-select>
        <div class="room-m-btn-row room-m-btn-row--2">
          <el-button type="primary" icon="el-icon-search" class="room-m-touch-btn" size="small" @click="HotelDetail"
            >查询政策</el-button
          >
          <el-button
            type="primary"
            plain
            icon="el-icon-plus"
            class="room-m-touch-btn"
            size="small"
            data-ebk-guide="room-add-type"
            :disabled="!canMaintainHotel"
            @click="proShowBaseList"
            >新增房型</el-button
          >
        </div>
      </div>
    </div>

    <div class="bg-w mt-3 p-2">
      <div class="room-week-board-outer" data-ebk-guide="room-week-board" :class="{ 'room-week-board-outer--m': ebkMobile }">
      <div class="room-week-board" :class="{ 'room-week-board--m': ebkMobile }">
      <!-- 表头（仅桌面：与折叠行标题重复，小屏隐藏） -->
      <p v-if="ebkMobile" class="room-m-scroll-hint">各政策下的日期以卡片网格展示，可点开房型查看明细。</p>
      <div v-show="!ebkMobile" class="ta-l row jc-sb fz-2 pt-2 pb-2 room-week-head">
        <div class="fl-sh left-w">
          <div class="fb title">房型名称</div>
        </div>
        <div class="fx-1">
                    <div class="row wrap">
                        <div
                            class="fb title week ta-c"
                            v-for="(item, index) in weekList"
                            :key="index"
                        >
                            {{ item }}
                        </div>
                    </div>
                </div>
        <div class="fl-sh left-w">
          <div class="fb title ta-c">操作</div>
        </div>
      </div>
      <el-collapse v-model="opened">
        <el-collapse-item v-for="(item, roomIdx) in tableData" :key="item.pro_base_id" :name="collapseItemName(item)">
          <template slot="title">
            <div
              v-if="ebkMobile"
              class="room-collapse-m"
            >
              <div class="room-collapse-m__head">
                <span
                  class="room-collapse-m__name room-collapse-m__name--tap"
                  role="button"
                  tabindex="0"
                  @click.stop="item.showDetail = !item.showDetail"
                  @keyup.enter.stop="item.showDetail = !item.showDetail"
                  >{{ item.house_type_name }}</span
                >
              </div>
              <div v-show="item.showDetail" class="room-collapse-m__grid" @click.stop>
                <div class="room-collapse-m__cell">
                  <div class="room-collapse-m__cell-hd">
                    <i class="iconfont icon-chuang room-collapse-m__ico"></i>
                    <span class="room-collapse-m__lbl">床型</span>
                  </div>
                  <span class="room-collapse-m__val">{{ item.bed_type_name || "—" }}</span>
                </div>
                <div class="room-collapse-m__cell">
                  <div class="room-collapse-m__cell-hd">
                    <i class="iconfont icon-fangwumianji room-collapse-m__ico"></i>
                    <span class="room-collapse-m__lbl">面积</span>
                  </div>
                  <span class="room-collapse-m__val">{{ item.rpb_room_size }}m²</span>
                </div>
                <div class="room-collapse-m__cell">
                  <div class="room-collapse-m__cell-hd">
                    <i class="iconfont icon-geren room-collapse-m__ico"></i>
                    <span class="room-collapse-m__lbl">成人</span>
                  </div>
                  <span class="room-collapse-m__val">{{ item.rpb_adult_count }}人</span>
                </div>
                <div class="room-collapse-m__cell">
                  <div class="room-collapse-m__cell-hd">
                    <i class="iconfont icon-ertongpiao room-collapse-m__ico"></i>
                    <span class="room-collapse-m__lbl">儿童</span>
                  </div>
                  <span class="room-collapse-m__val">{{ item.rpb_child_count }}人</span>
                </div>
                <div class="room-collapse-m__cell">
                  <div class="room-collapse-m__cell-hd">
                    <i class="iconfont icon-louti room-collapse-m__ico"></i>
                    <span class="room-collapse-m__lbl">楼层</span>
                  </div>
                  <span class="room-collapse-m__val">{{ item.rpb_room_floor }}层</span>
                </div>
                <div class="room-collapse-m__cell">
                  <div class="room-collapse-m__cell-hd">
                    <i class="iconfont icon-chuanghu-kai room-collapse-m__ico"></i>
                    <span class="room-collapse-m__lbl">窗户</span>
                  </div>
                  <span class="room-collapse-m__val">{{
                    item.rpb_has_windows == 0
                      ? "无窗"
                      : item.rpb_has_windows == 1
                        ? "有窗"
                        : "部分有窗"
                  }}</span>
                </div>
                <div class="room-collapse-m__cell">
                  <div class="room-collapse-m__cell-hd">
                    <i class="iconfont icon-wifi room-collapse-m__ico"></i>
                    <span class="room-collapse-m__lbl">网络</span>
                  </div>
                  <span class="room-collapse-m__val">{{
                    item.rpb_has_broadband == 1 ? "有WiFi" : "无WiFi"
                  }}</span>
                </div>
                <div class="room-collapse-m__cell">
                  <div class="room-collapse-m__cell-hd">
                    <i
                      class="iconfont room-collapse-m__ico"
                      :class="
                        item.rpb_non_smoking == 0
                          ? 'icon-jinyanqu'
                          : 'icon-qitalaji-yantou'
                      "
                    ></i>
                    <span class="room-collapse-m__lbl">吸烟</span>
                  </div>
                  <span class="room-collapse-m__val">{{
                    item.rpb_non_smoking == 0 ? "禁烟" : "可吸烟"
                  }}</span>
                </div>
              </div>
              <div class="room-collapse-m__foot" @click.stop>
                <div class="room-collapse-m__foot-duo">
                  <div class="room-collapse-m__btn-wrap">
                    <i
                      class="el-collapse-item__arrow el-icon-arrow-right room-collapse-m__panel-arrow"
                      :class="{ 'is-active': roomCollapseItemActive(item) }"
                      role="button"
                      tabindex="0"
                      title="展开或收起政策与房价"
                      @click.stop="toggleRoomCollapseFromFoot($event)"
                      @keyup.enter.stop="toggleRoomCollapseFromFoot($event)"
                    />
                    <el-button
                      type="primary"
                      plain
                      size="mini"
                      class="room-collapse-m__btn"
                      icon="el-icon-search"
                      @click.stop="editType(item)"
                      >查看房型</el-button
                    >
                  </div>
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    class="room-collapse-m__btn"
                    icon="el-icon-plus"
                    :disabled="!canMaintainHotel"
                    @click.stop="addPolicy(item)"
                    >添加政策</el-button
                  >
                </div>
              </div>
            </div>
            <div
              v-else
              class="row jc-sb ai-fs pt-1 pb-1 room-collapse-title-row"
              style="width: 100%"
            >
              <div class="fx-1 row ai-c room-collapse-name-row">
                <div class="con room-type-name-text">
                  {{ item.house_type_name }}
                </div>
                <i
                  class="cur-p ml-1 room-collapse-toggle"
                  style="margin-top: 2.9px"
                  :class="
                    item.showDetail
                      ? 'el-icon-arrow-left'
                      : 'el-icon-arrow-right'
                  "
                  @click.stop="item.showDetail = !item.showDetail"
                ></i>
                <div class="ml-3 fz-3 fc-g room-collapse-meta" v-show="item.showDetail">
                  <span title="床型名称">
                    <i class="iconfont icon-chuang"></i>
                    {{ item.bed_type_name }}
                  </span>
                  <span class="ml-2" title="房型面积">
                    <i class="iconfont icon-fangwumianji"></i>
                    {{ item.rpb_room_size }}m²
                  </span>
                  <span class="ml-2" title="成人数">
                    <i class="iconfont icon-geren"></i>
                    {{ item.rpb_adult_count }}人
                  </span>
                  <span class="ml-2" title="儿童数">
                    <i class="iconfont icon-ertongpiao"></i>
                    {{ item.rpb_child_count }}人
                  </span>
                  <span class="ml-2" title="楼层">
                    <i class="iconfont icon-louti"></i>
                    {{ item.rpb_room_floor }}层
                  </span>
                  <span class="ml-2" title="窗户">
                    <i class="iconfont icon-chuanghu-kai"></i>
                    <span v-if="item.rpb_has_windows == 0">无窗</span>
                    <span v-if="item.rpb_has_windows == 1">有窗</span>
                    <span v-if="item.rpb_has_windows == 2">部分有窗</span>
                  </span>
                  <span class="ml-2" :title="
                                            item.rpb_has_broadband == 1
                                                ? '有免费WiFi'
                                                : '无免费WiFi'
                                        ">
                    <i class="iconfont icon-wifi"></i>
                    <span>{{
                                            item.rpb_has_broadband == 1
                                                ? "有WiFi"
                                                : "无WiFi"
                                        }}</span>
                  </span>
                  <span class="ml-2" :title="
                                            item.rpb_non_smoking == 0
                                                ? '禁烟'
                                                : '部分客房可吸烟'
                                        ">
                    <i class="iconfont" :class="
                                                item.rpb_non_smoking == 0
                                                    ? 'icon-jinyanqu'
                                                    : 'icon-qitalaji-yantou'
                                            "></i>
                  </span>
                </div>
              </div>
              <div class="fl-sh left-w row ai-c room-collapse-ops">
                <el-tooltip content="查看房型" placement="top">
                  <i class="el-icon-search cur-p fz-1 room-collapse-ico" @click.stop="editType(item)"></i>
                </el-tooltip>
                <el-tooltip content="新增房型政策" placement="top">
                  <i
                    class="el-icon-plus fz-1 room-collapse-ico"
                    :class="canMaintainHotel ? 'cur-p' : 'room-collapse-ico--disabled'"
                    @click.stop="addPolicy(item)"
                  ></i>
                </el-tooltip>
              </div>
            </div>
          </template>
          <!-- 房价房态 -->
          <div v-if="item.pro_fac" class="table-tt table-bb border-ll border-rr">
            <div
              class="row jc-sb ai-st room-policy-row"
              :class="{ 'room-policy-row--m': ebkMobile }"
              v-for="(tab, num) in item.pro_fac"
              :key="num"
            >
              <div class="left-w pl-3 room-policy-head" :class="{ 'room-policy-head--m': ebkMobile }">
                <span class="room-policy-head__name">{{
                  tab.policy_name || "—"
                }}</span>
                <div class="room-policy-head__chips">
                  <el-tag
                    size="small"
                    type="info"
                    effect="plain"
                    class="room-policy-head__tag"
                    >{{ policyBreakfastLabel(tab) }}</el-tag
                  >
                  <el-tag
                    size="small"
                    :type="tab.policy_up == 1 ? 'success' : 'warning'"
                    effect="plain"
                    class="room-policy-head__tag"
                    >{{ tab.policy_up == 1 ? "已上架" : "已下架" }}</el-tag
                  >
                </div>
              </div>
              <div
                class="fx-1 border-ll border-rr room-policy-stock-wrap"
              >
                <div class="row wrap" v-if="tab.stock" :class="{ 'room-policy-stock-inner': ebkMobile }">
                  <div class="con week pl-2 pr-2 pt-1 pb-1" :class="{
                                            'border-ll': charge % 7 != 0,
                                            'table-bb':
                                                tab.stock.length % 7 == 0
                                                    ? 7 *
                                                      Math.floor(
                                                          (tab.stock.length -
                                                              1) /
                                                              7
                                                      )
                                                    : 7 *
                                                          Math.floor(
                                                              tab.stock.length /
                                                                  7
                                                          ) >
                                                          charge &&
                                                      tab.stock.length > 7,
                                            'border-rr':
                                                charge ==
                                                    tab.stock.length - 1 &&
                                                charge % 7 != 6,
                                        }" v-for="(val, charge) in tab.stock" :key="charge">
                    <div class="fc-sub row jc-sb ai-c fz-3">
                      <span>{{ val.rs_time }}({{getReturnWeek(val.rs_time)}})</span>
                      <div>
                        <el-tooltip :content="
                                                        val.opening_sale == 1
                                                            ? '已开房'
                                                            : '已关房'
                                                    " placement="top">
                          <i
                            class="iconfont room-stock-switch-hit"
                            :class="[
                              val.opening_sale == 1
                                ? 'fc-m icon-kaiguan-kai'
                                : 'fc-e icon-kaiguan-guan',
                              canMaintainHotel ? 'cur-p' : 'room-stock-switch-hit--readonly',
                            ]"
                            @click="
                              changeSwitch(item, tab, val)
                            "
                          ></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <div class="mt-1 row jc-sb">
                      <div class="fc-wa">
                        ￥{{ val.rs_cost }}
                      </div>
                      <div class="fc-sub fz-3">
                        余{{ val.rs_stock }}/间
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="fl-sh left-w row jc-c room-policy-actions-col"
                :class="{ 'room-policy-actions-col--m': ebkMobile }"
                :data-ebk-guide="roomIdx === 0 ? 'room-price-status' : null"
              >
                <template v-if="ebkMobile">
                  <el-button
                    type="primary"
                    plain
                    size="small"
                    class="room-m-touch-btn room-policy-action-btn"
                    :disabled="!canMaintainHotel"
                    @click="editPolicy(item, tab)"
                    >政策</el-button
                  >
                  <el-button
                    type="primary"
                    plain
                    size="small"
                    class="room-m-touch-btn room-policy-action-btn"
                    :disabled="!canMaintainHotel"
                    @click="editPrice(item, tab, 1)"
                    >房价</el-button
                  >
                  <el-button
                    type="primary"
                    plain
                    size="small"
                    class="room-m-touch-btn room-policy-action-btn"
                    :disabled="!canMaintainHotel"
                    @click="editPrice(item, tab, 2)"
                    >房态</el-button
                  >
                </template>
                <template v-else>
                  <el-button
                    :disabled="!canMaintainHotel"
                    @click="editPolicy(item, tab)"
                    type="text"
                    size="small"
                    >政策</el-button
                  >
                  <el-tooltip content="点击修改房价" placement="top">
                    <el-button
                      :disabled="!canMaintainHotel"
                      @click="editPrice(item, tab, 1)"
                      type="text"
                      size="small"
                      >房价</el-button
                    >
                  </el-tooltip>
                  <el-tooltip content="点击修改房态" placement="top">
                    <el-button
                      :disabled="!canMaintainHotel"
                      @click="editPrice(item, tab, 2)"
                      type="text"
                      size="small"
                      >房态</el-button
                    >
                  </el-tooltip>
                </template>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <div class="title mt-3 fz-3" v-if="tableData.length == 0">
        暂无数据
      </div>
      </div>
      </div>
    </div>
    <div class="room-log-block">
      <div v-show="!ebkMobile" class="row jc-sb mt-3 ai-c wrap">
        <div class="fb fc-m ml-2">房型日志</div>
        <div class="ta-r row ai-c wrap room-log-desk-actions">
          <el-date-picker v-model="logTime" type="daterange" :unlink-panels="ebkMobile" size="small" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" icon="el-icon-search" class="ml-3 pl-3 mt-1" @click="searchLog"
            size="small">查询日志</el-button>
        </div>
      </div>
      <div v-show="ebkMobile" class="room-m-log mt-3">
        <div class="room-m-section-title">房型日志</div>
        <el-date-picker
          v-model="logTime"
          class="room-m-control"
          type="daterange"
          :unlink-panels="ebkMobile"
          size="small"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
        <el-button
          type="primary"
          icon="el-icon-search"
          size="small"
          class="room-m-log-btn room-m-touch-btn"
          @click="searchLog"
          >查询日志</el-button
        >
      </div>
      <div v-show="!ebkMobile" class="table-scroll-x room-log-table-wrap">
        <el-table
          :data="logs"
          stripe
          size="small"
          style="width: 100%"
          class="mt-3 pt-3"
          highlight-current-row
        >
          <el-table-column prop="dt" label="创建时间"></el-table-column>
          <el-table-column prop="ip" label="IP地址"></el-table-column>
          <el-table-column prop="logCategory" label="日志分类"></el-table-column>
          <el-table-column prop="content" label="日志内容"></el-table-column>
        </el-table>
      </div>
      <div v-show="ebkMobile" class="room-m-log-cards mt-3">
        <template v-if="!logs || !logs.length">
          <div class="room-m-log-empty">暂无日志记录</div>
        </template>
        <template v-else>
          <div
            v-for="(row, idx) in logs"
            :key="'room-log-' + logPage + '-' + idx + '-' + (row.dt || '') + '-' + (row.ip || '')"
            class="room-m-log-card"
          >
            <div class="room-m-log-card__hd">
              <el-tag size="small" type="info" effect="plain" class="room-m-log-card__tag">{{
                row.logCategory || "—"
              }}</el-tag>
            </div>
            <div class="room-m-log-card__row">
              <span class="room-m-log-card__k">创建时间</span>
              <span class="room-m-log-card__v">{{ row.dt || "—" }}</span>
            </div>
            <div class="room-m-log-card__row">
              <span class="room-m-log-card__k">IP地址</span>
              <span class="room-m-log-card__v">{{ row.ip || "—" }}</span>
            </div>
            <div v-if="row.content" class="room-m-log-card__body">
              <div class="room-m-log-card__k room-m-log-card__k--block">日志内容</div>
              <div class="room-m-log-card__text">{{ row.content }}</div>
            </div>
          </div>
        </template>
      </div>
      <div class="mt-3 pt-3 ta-c room-log-pager" :class="{ 'room-log-pager--m': ebkMobile }">
        <el-pagination
          background
          @size-change="handleLogSizeChange"
          @current-change="handleLogCurrentChange"
          :current-page="logPage"
          :page-sizes="[5, 10]"
          :page-size="logLimit"
          :layout="ebkMobile ? 'total, prev, pager, next' : 'total, sizes, prev, pager, next, jumper'"
          :small="ebkMobile"
          :pager-count="ebkMobile ? 5 : 7"
          :total="logTotal"
        />
      </div>
    </div>

    <!-- 新增房型弹框 -->
    <el-dialog
      title="新增房型"
      :visible.sync="centerDialogVisible"
      :width="ebkMobile ? '92%' : '75%'"
      :top="ebkMobile ? '4vh' : '15vh'"
      :custom-class="dialogMobileClass"
      center
    >
      <div v-show="!ebkMobile" class="table-scroll-x">
        <el-table
          :data="baseRoomList"
          stripe
          style="width: 100%"
          class="mt-3 pt-3"
          size="small"
          height="500"
        >
          <el-table-column prop="house_type_name" label="房型名称"></el-table-column>
          <el-table-column prop="rpb_adult_count" label="成人数"></el-table-column>
          <el-table-column prop="rpb_child_count" label="儿童数"></el-table-column>
          <el-table-column prop="windowsName" label="是否有窗"></el-table-column>
          <el-table-column prop="wifi" label="是否有宽带"></el-table-column>
          <el-table-column prop="smoke" label="无烟处理"></el-table-column>
          <el-table-column prop="rpb_room_floor" label="楼层"></el-table-column>
          <el-table-column prop="rpb_room_size" label="房型面积/㎡"></el-table-column>
          <el-table-column prop="operate" label="操作">
            <template slot-scope="scope">
              <el-button
                type="primary"
                plain
                size="small"
                class="ebk-room-table-action"
                :disabled="!canMaintainHotel"
                @click="addRoom(scope.row)"
                >新增房型</el-button
              >
              <!-- <el-popconfirm
                            title="确定新增该房型数据吗？"
                            @confirm="addRoom(scope.row)"
                        >

                        </el-popconfirm> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-show="ebkMobile" class="room-m-addbase-list">
        <template v-if="!baseRoomList || !baseRoomList.length">
          <div class="room-m-addbase-empty">暂无基础房型数据</div>
        </template>
        <template v-else>
          <div
            v-for="(row, idx) in baseRoomList"
            :key="'addbase-' + idx + '-' + (row.house_type_name || '')"
            class="room-m-addbase-card"
          >
          <div class="room-m-addbase-card__title">{{ row.house_type_name || "—" }}</div>
          <div class="room-m-addbase-card__grid">
            <div class="room-m-addbase-cell">
              <span class="room-m-addbase-cell__lbl">成人数</span>
              <span class="room-m-addbase-cell__val">{{ row.rpb_adult_count != null ? row.rpb_adult_count : "—" }}</span>
            </div>
            <div class="room-m-addbase-cell">
              <span class="room-m-addbase-cell__lbl">儿童数</span>
              <span class="room-m-addbase-cell__val">{{ row.rpb_child_count != null ? row.rpb_child_count : "—" }}</span>
            </div>
            <div class="room-m-addbase-cell">
              <span class="room-m-addbase-cell__lbl">是否有窗</span>
              <span class="room-m-addbase-cell__val">{{ row.windowsName || "—" }}</span>
            </div>
            <div class="room-m-addbase-cell">
              <span class="room-m-addbase-cell__lbl">是否有宽带</span>
              <span class="room-m-addbase-cell__val">{{ row.wifi || "—" }}</span>
            </div>
            <div class="room-m-addbase-cell">
              <span class="room-m-addbase-cell__lbl">无烟处理</span>
              <span class="room-m-addbase-cell__val">{{ row.smoke || "—" }}</span>
            </div>
            <div class="room-m-addbase-cell">
              <span class="room-m-addbase-cell__lbl">楼层</span>
              <span class="room-m-addbase-cell__val">{{ row.rpb_room_floor != null && row.rpb_room_floor !== "" ? row.rpb_room_floor : "—" }}</span>
            </div>
            <div class="room-m-addbase-cell room-m-addbase-cell--full">
              <span class="room-m-addbase-cell__lbl">房型面积/㎡</span>
              <span class="room-m-addbase-cell__val">{{
                row.rpb_room_size != null && row.rpb_room_size !== "" ? row.rpb_room_size : "—"
              }}</span>
            </div>
          </div>
          <el-button
            type="primary"
            plain
            size="small"
            class="room-m-addbase-card__btn room-m-touch-btn"
            :disabled="!canMaintainHotel"
            @click="addRoom(row)"
            >新增房型</el-button
          >
          </div>
        </template>
      </div>
    </el-dialog>

    <!-- 查看房型弹框 -->
    <el-dialog
      title="房型信息"
      :visible.sync="editTypeWrapper"
      :width="ebkMobile ? '92%' : '40%'"
      :top="ebkMobile ? '4vh' : '15vh'"
      :custom-class="dialogMobileClass"
      center
    >
      <div>
        <el-card class="box-card" :body-style="bodyStyle">
          <div slot="header" class="clearfix ta-l fz-1 fb">
            <span>{{ chooseHotel.house_type_name }}</span>
          </div>
          <div>
            <el-descriptions
              class="margin-top"
              title=""
              :column="ebkMobile ? 1 : 2"
              :direction="ebkMobile ? 'vertical' : 'horizontal'"
              size="small"
              border
            >
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-film"></i>
                  床型名称
                </template>
                {{ chooseHotel.bed_type_name }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-s-custom"></i>
                  成年人数
                </template>
                {{ chooseHotel.rpb_adult_count }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-menu"></i>
                  是否有窗
                </template>
                {{
                                    chooseHotel.rpb_has_windows == 1
                                        ? "有窗"
                                        : chooseHotel.res_up == 0
                                        ? "无窗"
                                        : "部分有窗"
                                }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-s-check"></i>
                  儿童人数
                </template>
                {{ chooseHotel.rpb_child_count }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-s-platform"></i>
                  宽带状态
                </template>
                {{
                                    chooseHotel.rpb_has_windows == 1
                                        ? "有宽带"
                                        : chooseHotel.res_up == 0
                                        ? "无宽带"
                                        : "部分宽带"
                                }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-smoking"></i>
                  无烟处理
                </template>
                {{
                                    chooseHotel.rpb_non_smoking == 1
                                        ? "有无烟处理"
                                        : "无无烟处理"
                                }}
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-house"></i>
                  房型楼层
                </template>
                {{ chooseHotel.rpb_room_floor }}层
              </el-descriptions-item>
              <el-descriptions-item>
                <template slot="label">
                  <i class="el-icon-box"></i>
                  房型面积
                </template>
                {{ chooseHotel.rpb_room_size }}㎡
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-card>
      </div>
    </el-dialog>

    <!-- 新增/编辑房型政策 -->
    <el-dialog
      :title="isEdit ? '编辑房型政策' : '新增房型政策'"
      :visible.sync="policyVisible"
      :width="ebkMobile ? '92%' : '40%'"
      :top="ebkMobile ? '3vh' : '15vh'"
      :custom-class="dialogMobileClass"
      @submit.native.prevent
      center
    >
      <div class="row jc-c">
        <el-form
          :label-position="ebkMobile ? 'top' : 'left'"
          :model="policychooseHotel"
          :rules="policyRules"
          ref="policychooseHotel"
          label-width="150px"
          size="small"
          class="demo-policychooseHotel room-policy-form"
        >
          <el-form-item label="政策名称" prop="policy_name">
            <el-input placeholder="请输入政策名称" v-model="policychooseHotel.policy_name" class="hundreds"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="早餐份数" prop="breakfast_count">
            <el-select v-model="policychooseHotel.breakfast_count" placeholder="早餐份数" class="hundreds">
              <el-option label="无早" value="0"></el-option>
              <el-option label="单早" value="1"></el-option>
              <el-option label="双份早餐" value="2"></el-option>
              <el-option label="三份早餐" value="3"></el-option>
              <el-option label="四份早餐" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入住类型" prop="occupancy_type">
            <el-select v-model="policychooseHotel.occupancy_type" placeholder="入住类型" class="hundreds">
              <el-option label="标准" value="0"></el-option>
            </el-select>
          </el-form-item>
          <div class="row jc-sb room-policy-inline-row" :class="{ 'room-policy-inline-row--m': ebkMobile }">
            <el-form-item label="最少连住天数" prop="check_in_days">
              <el-input-number v-model="policychooseHotel.check_in_days" :min="1" label=""></el-input-number>
            </el-form-item>
            <el-form-item label="最小提前预定天数" prop="beforehand_booking_day">
              <el-input-number v-model="
                                    policychooseHotel.beforehand_booking_day
                                " :min="0" :max="10" label=""></el-input-number>
            </el-form-item>
          </div>
          <el-form-item label="房型可预订开始时间" prop="reserve_time_start">
            <el-time-picker placeholder="选择开始时间" v-model="policychooseHotel.reserve_time_start"
              :defaule-value="defaultValue" value-format="HH:mm:ss" style="width: 100%"></el-time-picker>
          </el-form-item>
          <el-form-item label="房型可预订结束时间" prop="reserve_time_end">
            <el-time-picker placeholder="选择结束时间" v-model="policychooseHotel.reserve_time_end" value-format="HH:mm:ss"
              style="width: 100%"></el-time-picker>
          </el-form-item>

          <el-form-item label="房型取消规则" prop="cancelPolicyType">
            <el-select v-model="policychooseHotel.cancelPolicyType" placeholder="房型取消规则" @change="changeType"
              class="hundreds">
              <el-option v-for="(item, index) in selectLetter" :key="index" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最晚取消日期" prop="cancelpolicyDay" v-if="policychooseHotel.cancelPolicyType == '5'">
            <el-select v-model="policychooseHotel.cancelpolicyDay" placeholder="最晚取消日期" style="width: 200px"
              @change="changeType">
              <el-option label="入住当天" value="0"></el-option>
              <el-option label="入住前1天" value="1"></el-option>
              <el-option label="入住前2天" value="2"></el-option>
              <el-option label="入住前3天" value="3"></el-option>
              <el-option label="入住前4天" value="4"></el-option>
              <el-option label="入住前5天" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最晚取消时间" prop="cancelpolicyTime" v-if="policychooseHotel.cancelPolicyType == '5'">
            <el-time-select v-model="policychooseHotel.cancelpolicyTime" @blur="changeType" :picker-options="{
                                start: '00:00',
                                step: '00:60',
                                end: '24:00',
                            }" style="width: 200px" placeholder="取消时间">
            </el-time-select>
          </el-form-item>
          <el-form-item label="上下架状态" prop="policy_up">
            <el-select v-model="policychooseHotel.policy_up" placeholder="上下架状态" class="hundreds">
              <el-option label="下架" value="0"></el-option>
              <el-option label="上架" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入住权益" prop="booking_notes">
              <el-input
                  placeholder="请输入入住权益"
                  v-model="policychooseHotel.booking_notes"
                  class="hundreds"
                  clearable
              ></el-input>
          </el-form-item>
          <el-form-item class="room-dialog-form-actions">
            <el-button class="ebk-dlg-btn-cancel" @click="policyVisible = false">取消</el-button>
            <el-button type="primary" class="ebk-dlg-btn-ok" @click="policySubmitForm('policychooseHotel')" native-type="submit">确定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 修改房价 -->
    <el-dialog
      title="修改房价"
      :visible.sync="priceVisible"
      :width="ebkMobile ? '92%' : '30%'"
      :top="ebkMobile ? '4vh' : '15vh'"
      :custom-class="dialogMobileClass"
      center
    >
      <el-tabs v-model="priceActiveName" type="card">
        <el-tab-pane label="按月份" name="accordingMonthPrice">
          <el-form :model="changePriceMonth" :rules="changePriceMonthRules" ref="changePriceMonthRules"
            label-width="80px" size="small" class="demo-chooseHotel">
            <el-form-item label="房型" prop="policy_id">
              <el-select class="hundred" v-model="changePriceMonth.policy_id" clearable size="small"
                placeholder="选择房型政策">
                <el-option v-for="(
                                        item, index
                                    ) in editPricePro.pro_fac" :key="index" :label="item.policy_name"
                  :value="item.policy_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="月份" prop="month">
              <el-checkbox-group v-model="changePriceMonth.month">
                <el-checkbox :disabled="Tmonth > item.value" v-for="(item, index) in months" name="type"
                  :label="item.value" :key="index">{{ item.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="底价" prop="rs_cost">
              <el-input-number v-model="changePriceMonth.rs_cost" @change="handleChange" :min="0" label="底价增减"
                size="small"></el-input-number>
            </el-form-item>
            <el-form-item class="room-dialog-form-actions">
              <el-button class="ebk-dlg-btn-cancel" @click="priceVisible = false">取消</el-button>
              <el-button
                type="primary"
                class="ebk-dlg-btn-ok"
                @click="submitPriceForm('changePriceMonthRules')"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="按天数" name="accordingDayPrice">
          <el-form :model="changePriceDay" :rules="changePriceDayRules" ref="changePriceDayRules" label-width="80px"
            size="small" class="demo-chooseHotel">
            <el-form-item label="房型政策" prop="policy_id">
              <el-select class="hundred" v-model="changePriceDay.policy_id" clearable size="small" placeholder="选择房型政策">
                <el-option v-for="(
                                        item, index
                                    ) in editPricePro.pro_fac" :key="index" :label="item.policy_name"
                  :value="item.policy_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间范围" prop="dates">
              <el-date-picker size="small" v-model="changePriceDay.dates" type="daterange" :unlink-panels="ebkMobile" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                :picker-options="pickerOptions0">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="选择周" prop="week">
              <el-checkbox-group v-model="changePriceDay.week">
                <el-checkbox v-for="(item, index) in weeks" name="type" :label="item.value"
                  :key="index">{{ item.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="房间底价" prop="rs_cost">
              <el-input-number v-model="changePriceDay.rs_cost" :min="0" label="底价增减" size="small"></el-input-number>
            </el-form-item>
            <el-form-item class="room-dialog-form-actions">
              <el-button class="ebk-dlg-btn-cancel" @click="priceVisible = false">取消</el-button>
              <el-button type="primary" class="ebk-dlg-btn-ok" @click="submitPriceForm('changePriceDayRules')">确定</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 修改房态 -->
    <el-dialog
      title="修改房态"
      :visible.sync="statusVisible"
      :width="ebkMobile ? '92%' : '30%'"
      :top="ebkMobile ? '4vh' : '15vh'"
      :custom-class="dialogMobileClass"
      center
    >
      <el-tabs v-model="statusctiveName" type="card">
        <el-tab-pane label="按月份" name="accordingMonthSatus">
          <el-form :model="changeStatusMonth" :rules="changeStatusMonthRules" ref="changeStatusMonthRules"
            label-width="80px" size="small" class="demo-chooseHotel">
            <el-form-item label="房型" prop="policy_id">
              <el-select class="hundred" v-model="changeStatusMonth.policy_id" clearable size="small"
                placeholder="选择房型政策">
                <el-option v-for="(
                                        item, index
                                    ) in editPricePro.pro_fac" :key="index" :label="item.policy_name"
                  :value="item.policy_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房态" prop="opening_sale">
              <el-radio v-model="changeStatusMonth.opening_sale" label="0">关房</el-radio>
              <el-radio v-model="changeStatusMonth.opening_sale" label="1">开房</el-radio>
            </el-form-item>
            <el-form-item label="月份" prop="month">
              <el-checkbox-group v-model="changeStatusMonth.month">
                <el-checkbox :disabled="Tmonth > item.value" v-for="(item, index) in months" name="type"
                  :label="item.value" :key="index">{{ item.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="增减" prop="jisuan">
              <el-radio v-model="changeStatusMonth.jisuan" label="plus">增加</el-radio>
              <el-radio v-model="changeStatusMonth.jisuan" label="reduce">减少</el-radio>
            </el-form-item>
            <el-form-item label="库存" prop="stockNum">
              <el-input-number v-model="changeStatusMonth.stockNum" @change="handleChange" :min="0" label="库存增减"
                size="small"></el-input-number>
            </el-form-item>
            <el-form-item class="room-dialog-form-actions">
              <el-button class="ebk-dlg-btn-cancel" @click="statusVisible = false">取消</el-button>
              <el-button
                type="primary"
                class="ebk-dlg-btn-ok"
                @click="submitStatusForm('changeStatusMonthRules')"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="按天数" name="accordingDaySatus">
          <el-form :model="changeStatusDay" :rules="changeStatusDayRules" ref="changeStatusDayRules" label-width="80px"
            size="small" class="demo-chooseHotel">
            <el-form-item label="房型" prop="policy_id">
              <el-select class="hundred" v-model="changeStatusDay.policy_id" clearable size="small"
                placeholder="选择房型政策">
                <el-option v-for="(
                                        item, index
                                    ) in editPricePro.pro_fac" :key="index" :label="item.policy_name"
                  :value="item.policy_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间范围" prop="dates">
              <el-date-picker size="small" v-model="changeStatusDay.dates" type="daterange" :unlink-panels="ebkMobile" range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                :picker-options="pickerOptions0">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="选择周" prop="week">
              <el-checkbox-group v-model="changeStatusDay.week">
                <el-checkbox v-for="(item, index) in weeks" name="type" :label="item.value"
                  :key="index">{{ item.label }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="房态" prop="opening_sale">
              <el-radio v-model="changeStatusDay.opening_sale" label="0">关房</el-radio>
              <el-radio v-model="changeStatusDay.opening_sale" label="1">开房</el-radio>
            </el-form-item>
            <el-form-item label="增减" prop="jisuan">
              <el-radio v-model="changeStatusDay.jisuan" label="plus">增加</el-radio>
              <el-radio v-model="changeStatusDay.jisuan" label="reduce">减少</el-radio>
            </el-form-item>
            <el-form-item label="库存" prop="stockNum">
              <el-input-number v-model="changeStatusDay.stockNum" @change="handleChange" :min="0" label="库存增减"
                size="small"></el-input-number>
            </el-form-item>
            <el-form-item class="room-dialog-form-actions">
              <el-button class="ebk-dlg-btn-cancel" @click="statusVisible = false">取消</el-button>
              <el-button
                type="primary"
                class="ebk-dlg-btn-ok"
                @click="submitStatusForm('changeStatusDayRules')"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 移动端：确认新增房型（挂 body，避免套在主弹窗里 MessageBox 裁切） -->
    <el-dialog
      title="提示"
      :visible.sync="addRoomConfirmVisible"
      append-to-body
      :width="ebkMobile ? '88%' : '420px'"
      :custom-class="
        'room-add-confirm-dialog' +
        (ebkMobile ? ' room-add-confirm-dialog--mobile' : '')
      "
      :close-on-click-modal="true"
      center
      @closed="addRoomConfirmRow = null"
    >
      <div class="room-add-confirm-body">
        <i
          class="el-icon-warning room-add-confirm-ico"
          aria-hidden="true"
        ></i>
        <div class="room-add-confirm-copy">
          <p class="room-add-confirm-text">要新增房型吗？</p>
          <p
            v-if="addRoomConfirmRow && addRoomConfirmRow.house_type_name"
            class="room-add-confirm-sub"
          >
            {{ addRoomConfirmRow.house_type_name }}
          </p>
        </div>
      </div>
      <span slot="footer" class="room-add-confirm-footer">
        <el-button
          size="medium"
          class="room-add-confirm-btn"
          @click="addRoomConfirmVisible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="medium"
          class="room-add-confirm-btn"
          @click="submitAddRoomConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import qs from "qs";
  import {
    Loading
  } from "element-ui";
  import mobileBreakpoint from "@/mixins/mobileBreakpoint";
  import supplierMaintain from "@/mixins/supplierMaintain";
  import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
  import featureGuideMixin from "@/mixins/featureGuideMixin";
  import { GUIDE_IDS } from "@/config/featureGuides";
  var options = {
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  };
  export default {
    name: "roomType",
    components: { PageBreadcrumb },
    mixins: [mobileBreakpoint, supplierMaintain, featureGuideMixin],
    data() {
      return {
        ebkFeatureGuideId: GUIDE_IDS.roomType,
        bodyStyle: {
          padding: "10px",
        },
        defaultValue: null,
        priceActiveName: "accordingMonthPrice",
        statusctiveName: "accordingMonthSatus",
        priceVisible: false,
        statusVisible: false,
        isEdit: 0,
        chooseRoom: "",
        days: "7",
        rs_time: "",
        userInfo: {},
        chooseHotel: {},
        centerDialogVisible: false,
        /** 移动端：确认新增房型（替代 $confirm） */
        addRoomConfirmVisible: false,
        addRoomConfirmRow: null,
        policyVisible: false,
        roomList: [],
        baseRoomList: [],
        tableData: [],
        opened: [],
        editTypeWrapper: false,
        rules: {
          house_type_name: [{
            required: true,
            message: "请输入房型名称",
            trigger: "blur",
          }, ],
          bed_type_name: [{
            required: true,
            message: "请输入床型名称",
            trigger: "blur",
          }, ],
          notice: [{
            required: true,
            message: "请选择房型状态",
            trigger: "blur",
          }, ],
          rpb_adult_count: [{
            required: true,
            message: "成年人数不可为空",
            trigger: "blur",
          }, ],
          rpb_child_count: [{
            required: true,
            message: "儿童人数不可为空",
            trigger: "blur",
          }, ],
          rpb_has_windows: [{
            required: true,
            message: "请选择窗户状态",
            trigger: "blur",
          }, ],
          rpb_has_broadband: [{
            required: true,
            message: "请选择宽带状态",
            trigger: "blur",
          }, ],
          rpb_room_floor: [{
            required: true,
            message: "请输入房型楼层",
            trigger: "blur",
          }, ],
          rpb_room_size: [{
            required: true,
            message: "请输入房型面积",
            trigger: "blur",
          }, ],
          rpb_non_smoking: [{
            required: true,
            message: "请选择烟雾处理状态",
            trigger: "blur",
          }, ],
        },
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        },
        weekList: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
        weeks: [{
            label: "周一",
            value: 1,
          },
          {
            label: "周二",
            value: 2,
          },
          {
            label: "周三",
            value: 3,
          },
          {
            label: "周四",
            value: 4,
          },
          {
            label: "周五",
            value: 5,
          },
          {
            label: "周六",
            value: 6,
          },
          {
            label: "周日",
            value: 7,
          },
        ],
        policychooseHotel: {
          policy_name: "",
          breakfast_count: "",
          occupancy_type: "",
          check_in_days: "",
          advanced_limit_days: "",
          beforehand_booking_day: "",
          reserve_time_start: "",
          reserve_time_end: "",
          cancel_time: "",
          forfeit_amount: 0,
          policy_up: "",
          BookingNotes: "",
          cancelPolicyType: "1",
          cancelpolicyDay: "0",
          cancelpolicyTime: "",
        },
        policyRules: {
          policy_name: [{
            required: true,
            message: "请输入政策名称",
            trigger: "blur",
          }, ],
          breakfast_count: [{
            required: true,
            message: "请选择早晨份数",
            trigger: "blur",
          }, ],
          occupancy_type: [{
            required: true,
            message: "请选择入住类型",
            trigger: "blur",
          }, ],
          check_in_days: [{
            required: true,
            message: "请输入最少连住天数",
            trigger: "blur",
          }, ],
          advanced_limit_days: [{
            required: true,
            message: "请输入最大提前预定天数",
            trigger: "blur",
          }, ],
          beforehand_booking_day: [{
            required: true,
            message: "最小提前预定天数",
            trigger: "blur",
          }, ],
          reserve_time_start: [{
            required: true,
            message: "请选择房型可预订开始时间",
            trigger: "blur",
          }, ],
          reserve_time_end: [{
            required: true,
            message: "请选择房型可预订结束时间",
            trigger: "blur",
          }, ],
          // forfeit_amount: [
          //     { required: true, message: "请输入罚金", trigger: "blur" },
          // ],
          policy_up: [{
            required: true,
            message: "请选择上下架状态",
            trigger: "blur",
          }, ],
          BookingNotes: [{
            required: true,
            message: "请输入酒店房型预订说明",
            trigger: "blur",
          }, ],
          cancelPolicyType: [{
            required: true,
            message: "请选择取消规则",
            trigger: "blur",
          }, ],
          cancelpolicyDay: [{
            required: true,
            message: "请选择取消日期",
            trigger: "blur",
          }, ],
          cancelpolicyTime: [{
            required: true,
            message: "请选择取消时间",
            trigger: "blur",
          }, ],
        },
        changePriceMonth: {
          res_id: "",
          house_type_name: "",
          pro_base_id: "",
          policy_name: "",
          policy_id: "",
          rs_cost: "",
          month: [],
        },
        changePriceDay: {
          house_type_name: "",
          pro_base_id: "",
          policy_name: "",
          policy_id: "",
          sdate: "",
          edate: "",
          rs_cost: "",
          week: [1, 2, 3, 4, 5, 6, 7],
          dates: "",
        },
        changePriceMonthRules: {
          policy_id: [{
            required: true,
            message: "请选择房型",
            trigger: "blur"
          }, ],
          month: [{
            type: "array",
            required: true,
            message: "请至少选择一个月份",
            trigger: "change",
          }, ],
          rs_cost: [{
            required: true,
            message: "底价不能为空",
            trigger: "blur",
          }, ],
        },
        changePriceDayRules: {
          policy_id: [{
            required: true,
            message: "请选择房型",
            trigger: "blur"
          }, ],
          dates: [{
            required: true,
            message: "请选择时间范围",
            trigger: "blur",
          }, ],
          week: [{
            type: "array",
            required: true,
            message: "请至少选择一个星期日",
            trigger: "change",
          }, ],
          rs_cost: [{
            required: true,
            message: "底价不能为空",
            trigger: "blur",
          }, ],
        },
        changeStatusMonth: {
          res_id: "",
          house_type_name: "",
          pro_base_id: "",
          policy_name: "",
          policy_id: "",
          month: [],
          opening_sale: "",
          stockNum: "",
          jisuan: "",
        },
        changeStatusDay: {
          house_type_name: "",
          pro_base_id: "",
          policy_name: "",
          policy_id: "",
          dates: "",
          sdate: "",
          edate: "",
          week: [1, 2, 3, 4, 5, 6, 7],
          opening_sale: "",
          stockNum: "",
          jisuan: "",
        },
        changeStatusMonthRules: {
          policy_id: [{
            required: true,
            message: "请选择房型",
            trigger: "blur"
          }, ],
          month: [{
            type: "array",
            required: true,
            message: "请至少选择一个月份",
            trigger: "change",
          }, ],
          rs_cost: [{
            required: true,
            message: "底价不能为空",
            trigger: "blur",
          }, ],
          opening_sale: [{
            required: true,
            message: "请选择房态",
            trigger: "change",
          }, ],
          jisuan: [{
            required: true,
            message: "请选择增减状态",
            trigger: "change",
          }, ],
          stockNum: [{
            required: true,
            message: "请选择库存数量",
            trigger: "blur",
          }, ],
        },
        changeStatusDayRules: {
          policy_id: [{
            required: true,
            message: "请选择房型",
            trigger: "blur"
          }, ],
          week: [{
            type: "array",
            required: true,
            message: "请至少选择一个星期日",
            trigger: "change",
          }, ],
          dates: [{
            required: true,
            message: "请选择时间范围",
            trigger: "blur",
          }, ],
          rs_cost: [{
            required: true,
            message: "底价不能为空",
            trigger: "blur",
          }, ],
          opening_sale: [{
            required: true,
            message: "请选择房态",
            trigger: "change",
          }, ],
          jisuan: [{
            required: true,
            message: "请选择增减状态",
            trigger: "change",
          }, ],
          stockNum: [{
            required: true,
            message: "请选择库存数量",
            trigger: "blur",
          }, ],
        },
        editPricePro: {},
        months: [],
        Tmonth: 1,
        selectLetter: [{
            label: "随时取消",
            value: "1",
          },
          {
            label: "不可取消",
            value: "2",
          },
          {
            label: "限时取消",
            value: "5",
          },
        ],
        monthDays: 30,
        logs: [],
        logTime: [],
        logPage: 1,
        logLimit: 5,
        logTotal: 0,
      };
    },
    computed: {
      pageBreadcrumbItems() {
        return [
          { label: "酒店列表", to: { path: "/hotel" } },
          { label: "房型列表" },
        ];
      },
      dialogMobileClass() {
        return this.ebkMobile ? "ebk-room-dialog--mobile" : "";
      },
      hotelUpStatusText() {
        const up = this.chooseHotel && this.chooseHotel.res_up;
        if (up == 1) return "上架";
        if (up == 0) return "下架";
        if (up != null && up !== "") return "手动下架";
        return "";
      },
      hotelUpTagType() {
        const up = this.chooseHotel && this.chooseHotel.res_up;
        if (up == 1) return "success";
        if (up == 0) return "info";
        return "warning";
      },
      hotelAddressText() {
        const h = this.chooseHotel || {};
        const parts = [h.city_name_chn, h.section_name_chn, h.res_adress].filter(
          (x) => x != null && String(x).trim() !== ""
        );
        return parts.length ? parts.join(" ") : "—";
      },
      hotelInfoBasicRows() {
        const h = this.chooseHotel || {};
        const rows = [
          {
            key: "phone",
            icon: "el-icon-phone",
            label: "酒店电话",
            value: h.res_phone || "—",
          },
          {
            key: "grade",
            icon: "el-icon-school",
            label: "酒店等级",
            value: h.grade || "—",
          },
          {
            key: "up",
            icon: "el-icon-data-line",
            label: "上架状态",
            value: this.hotelUpStatusText || "—",
          },
          {
            key: "built",
            icon: "el-icon-stopwatch",
            label: "建造时间",
            value: this.formatHotelDate(h.rb_when_built),
          },
          {
            key: "reno",
            icon: "el-icon-time",
            label: "装修时间",
            value: this.formatHotelDate(h.rb_renovation_date),
          },
        ];
        return rows;
      },
      /** 移动端 2×2 摘要（上架状态已在标题 tag 展示，不再重复） */
      hotelInfoMobileFactRows() {
        return this.hotelInfoBasicRows.filter((r) =>
          ["phone", "grade", "built", "reno"].includes(r.key)
        );
      },
      hotelIntroHtml() {
        return this.formatHotelIntroHtml(
          this.chooseHotel && this.chooseHotel.rb_info
        );
      },
    },
    watch: {
      centerDialogVisible(val) {
        if (!val) {
          this.addRoomConfirmVisible = false;
          this.addRoomConfirmRow = null;
        }
      },
      ebkMobile(isMobile) {
        if (!isMobile) {
          this.addRoomConfirmVisible = false;
          this.addRoomConfirmRow = null;
        }
      },
    },
    created() {
      this.userInfo = JSON.parse(this.getToken("userInfo"));
      var nowDate = new Date();
      var year = nowDate.getFullYear();
      var month =
        nowDate.getMonth() + 1 < 10 ?
        "0" + (nowDate.getMonth() + 1) :
        nowDate.getMonth() + 1;
      var day =
        nowDate.getDate() < 10 ?
        "0" + nowDate.getDate() :
        nowDate.getDate();
      this.rs_time = year + "-" + month + "-" + day;
      this.Tmonth = month;
      // 每个月一共有多少天
      this.monthDays = new Date(year, month, 0).getDate();

      for (let i = 1; i < 13; i++) {
        this.months.push({
          label: i + "月",
          value: i,
        });
      }
      this.logTime.push(year + "-" + "01" + "-" + "01");
      this.logTime.push(year + "-" + month + "-" + day);
      this.initRoomTypeFromStorage(true);
    },
    activated() {
      this.refreshUserInfoFromToken();
      this.initRoomTypeFromStorage(false);
    },
    methods: {
      formatHotelDate(val) {
        if (val == null || val === "") return "—";
        const s = String(val).trim();
        if (!s || /^1970-01-01/.test(s)) return "—";
        return s;
      },
      formatHotelIntroHtml(raw) {
        if (raw == null || String(raw).trim() === "") {
          return '<span class="room-hotel-intro--empty">暂无介绍</span>';
        }
        let s = String(raw)
          .replace(/<script[\s\S]*?<\/script>/gi, "")
          .replace(/<\/script>/gi, "");
        s = s.replace(/\r\n/g, "\n").replace(/\n/g, "<br>");
        return s;
      },
      /** 当前登录供应商编码（editProBasePolicy 等接口 POST 必填） */
      getSupplierCode() {
        const u = this.userInfo || {};
        const code = u.code != null ? String(u.code).trim() : "";
        return code;
      },
      /**
       * 从酒店列表进入时会先写 localStorage；本页在 keep-alive 下 created 只执行一次，
       * 需在 activated 中重新读取，否则仍显示上一次选中的酒店。
       * @param {boolean} fromCreated 首次创建时跳过去重，避免与旧 state 比较失误
       */
      refreshUserInfoFromToken() {
        try {
          const raw = this.getToken("userInfo");
          if (raw) {
            this.userInfo = JSON.parse(raw);
          }
        } catch (e) {
          /* ignore */
        }
      },
      initRoomTypeFromStorage(fromCreated) {
        var raw = localStorage.getItem("chooseHotel");
        if (!raw) {
          return;
        }
        var next;
        try {
          next = JSON.parse(raw);
        } catch (e) {
          return;
        }
        if (!next || next.res_id === undefined || next.res_id === null) {
          return;
        }
        var prevId = this.chooseHotel && this.chooseHotel.res_id;
        if (
          !fromCreated &&
          prevId !== undefined &&
          prevId !== null &&
          String(prevId) === String(next.res_id)
        ) {
          return;
        }
        this.chooseHotel = next;
        this.HotelDetail();
        this.getLog();
      },
      roomCollapseItemActive(item) {
        var n = this.collapseItemName(item);
        return this.opened.indexOf(n) > -1;
      },
      toggleRoomCollapseFromFoot(ev) {
        var t = ev.currentTarget;
        var row = t && t.closest && t.closest(".el-collapse-item");
        if (row) {
          var h = row.querySelector(".el-collapse-item__header");
          if (h) {
            h.click();
          }
        }
      },
      collapseItemName(item) {
        return item && item.pro_base_id != null ? String(item.pro_base_id) : "";
      },
      // 修改酒店备注
      edidRemarks() {
        if (!this.assertCanMaintain()) {
          return;
        }
        Loading.service(options);
        let data = {
          res_id: this.chooseHotel.res_id,
          remarks: this.chooseHotel.rb_deposit_and_prepaid
        }
        this.$axios
          .edidRemarks(qs.stringify(data))
          .then((res) => {
            if (res) {
              Loading.service(options).close();
              this.HotelDetail();
            }
          })
          .catch((err) => {
            Loading.service(options).close();
          });
      },
      // 修改房价正则
      submitPriceForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.priceActiveName == "accordingMonthPrice") {
              // 按月份修改房价
              this.editEveryPriceSomeMonth();
            } else {
              this.editEveryPriceSomeWeek();
            }
          } else {
            return false;
          }
        });
      },
      // 修改房态正则
      submitStatusForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.statusctiveName == "accordingMonthSatus") {
              this.editEveryStockSomeMonth();
            } else {
              this.editEveryStockSomeWeek();
            }
          } else {
            return false;
          }
        });
      },
      // 按月份修改房价
      editEveryPriceSomeMonth() {
        if (!this.assertCanMaintain()) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.changePriceMonth));
        data.res_id = this.chooseHotel.res_id;
        Loading.service(options);
        this.$axios
          .editEveryPriceSomeMonth(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            if (res) {
              this.HotelDetail();
              this.priceVisible = false;
            }
          })
          .catch((err) => {});
      },
      // 按日期修改房价
      editEveryPriceSomeWeek() {
        if (!this.assertCanMaintain()) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.changePriceDay));
        data.sdate = data.dates[0];
        data.edate = data.dates[1];
        data.res_id = this.chooseHotel.res_id;
        delete data.dates;
        Loading.service(options);
        this.$axios
          .editEveryPriceSomeWeek(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            if (res) {
              this.HotelDetail();
              this.priceVisible = false;
            }
          })
          .catch((err) => {});
      },
      // 按月份修改房态
      editEveryStockSomeMonth() {
        if (!this.assertCanMaintain()) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.changeStatusMonth));
        data.res_id = this.chooseHotel.res_id;
        Loading.service(options);
        this.$axios
          .editEveryStockSomeMonth(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            if (res) {
              this.HotelDetail();
              this.statusVisible = false;
            }
          })
          .catch((err) => {});
      },
      // 按日期修改房价
      editEveryStockSomeWeek() {
        if (!this.assertCanMaintain()) {
          return;
        }
        let data = JSON.parse(JSON.stringify(this.changeStatusDay));
        data.sdate = data.dates[0];
        data.edate = data.dates[1];
        data.res_id = this.chooseHotel.res_id;
        delete data.dates;
        Loading.service(options);
        this.$axios
          .editEveryStockSomeWeek(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            if (res) {
              this.HotelDetail();
              this.statusVisible = false;
            }
          })
          .catch((err) => {});
      },
      handleChange(e) {
        this.changePriceMonth.rs_cost = e;
      },
      changeSwitch(item, tab, val) {
        if (!this.assertCanMaintain()) {
          return;
        }
        this.getEveryPriceStock(item, tab, val, 1);
      },
      // 点击价格/库存 数据赋值
      editPrice(item, tab, val) {
        if (!this.assertCanMaintain()) {
          return;
        }
        let obj = (({
          res_id,
          house_type_name,
          pro_base_id
        }) => ({
          res_id,
          house_type_name,
          pro_base_id,
        }))(item);
        let obj2 = (({
          policy_name,
          policy_id
        }) => ({
          policy_name,
          policy_id,
        }))(tab);

        if (val == 1) {
          Object.keys(this.changePriceMonth).map((key) => {
            this.changePriceMonth[key] =
              obj[key] || this.changePriceMonth[key];
          });
          Object.keys(this.changePriceMonth).map((key) => {
            this.changePriceMonth[key] =
              obj2[key] || this.changePriceMonth[key];
          });

          Object.keys(this.changePriceDay).map((key) => {
            this.changePriceDay[key] =
              obj[key] || this.changePriceDay[key];
          });
          Object.keys(this.changePriceDay).map((key) => {
            this.changePriceDay[key] =
              obj2[key] || this.changePriceDay[key];
          });
          this.priceVisible = true;
        } else {
          Object.keys(this.changeStatusMonth).map((key) => {
            this.changeStatusMonth[key] =
              obj[key] || this.changeStatusMonth[key];
          });
          Object.keys(this.changeStatusMonth).map((key) => {
            this.changeStatusMonth[key] =
              obj2[key] || this.changeStatusMonth[key];
          });

          Object.keys(this.changeStatusDay).map((key) => {
            this.changeStatusDay[key] =
              obj[key] || this.changeStatusDay[key];
          });
          Object.keys(this.changeStatusDay).map((key) => {
            this.changeStatusDay[key] =
              obj2[key] || this.changeStatusDay[key];
          });
          this.statusVisible = true;
        }

        this.editPricePro = item;
      },
      // 获取底价
      getEveryPriceStock(item, tab, val, changeStatus) {
        let data = {
          policy_id: tab.policy_id,
          rs_time: val.rs_time,
          res_id: this.chooseHotel.res_id,
        };
        Loading.service(options);
        this.$axios
          .getEveryPriceStock(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            if (changeStatus == 1) {
              this.editEveryStock(item, tab, val, res.rs_id);
            }
          })
          .catch((err) => {});
      },
      // 修改开关房状态
      editEveryStock(item, tab, val, rs_id) {
        if (!this.assertCanMaintain()) {
          return;
        }
        let data = {
          rs_id: rs_id,
          policy_id: tab.policy_id,
          "PSI_Hotel_everyStockEditForm_editForm_rs_time-inputEl": val.rs_time,
          opening_sale: val.opening_sale,
          stockNum: val.rs_stock,
          jisuan: "plus",
          house_type_name: item.house_type_name,
          policy_name: tab.policy_name
        };
        Loading.service(options);
        this.$axios
          .editEveryStock(qs.stringify(data))
          .then((res) => {
            if (res) {
              if (val.opening_sale == 1) {
                val.opening_sale = 0;
              } else {
                val.opening_sale = 1;
              }
            }
            Loading.service(options).close();
          })
          .catch((err) => {});
      },
      // 日期获取周几
      getReturnWeek(dateString) {
        var dateArray = dateString.split("-");
        let date = new Date(
          dateArray[0],
          parseInt(dateArray[1] - 1),
          dateArray[2]
        );
        let weekday = "周" + "日一二三四五六".charAt(date.getDay());
        return weekday
      },
      // 点击编辑政策
      editPolicy(e, a) {
        if (!this.assertCanMaintain()) {
          return;
        }
        this.chooseRoom = e.pro_base_id;
        this.isEdit = 1;
        this.policychooseHotel = a;
        if (this.policychooseHotel.cancelpolicy) {
          let cancelPolicy = JSON.parse(
            JSON.stringify(this.policychooseHotel.cancelpolicy)
          );
          this.policychooseHotel.cancelPolicyType =
            cancelPolicy.cancelPolicyType.toString();
          if (this.policychooseHotel.cancelPolicyType == 5) {
            let time = cancelPolicy.policyInfo.timeBefore;
            this.policychooseHotel.cancelpolicyDay = Math.floor(
              time / 24
            );
            this.policychooseHotel.cancelpolicyTime =
              24 -
              Math.round((time / 24 - Math.floor(time / 24)) * 24) +
              ":00:00";
          }
        }
        this.policyVisible = true;
      },
      changeType() {
        this.$forceUpdate();
      },
      // 点击新增政策
      addPolicy(e) {
        if (!this.assertCanMaintain()) {
          return;
        }
        this.chooseRoom = e.pro_base_id;
        this.isEdit = 0;
        Object.keys(this.policychooseHotel).map((key) => {
          this.policychooseHotel[key] = "";
        });
        this.policychooseHotel.reserve_time_start = "00:00:00";
        this.policychooseHotel.reserve_time_end = "23:59:59";
        this.policychooseHotel.cancelPolicyType = "1";
        this.policyVisible = true;
      },
      // 验证通过即发送编辑or新增请求
      policySubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.sendAddPolicy();
          } else {
            return false;
          }
        });
      },
      // 编辑新增房型政策
      sendAddPolicy() {
        if (!this.assertCanMaintain()) {
          return;
        }
        const code = this.getSupplierCode();
        if (!code) {
          this.$message.warning("未获取到供应商编码，请重新登录并选择供应商");
          return;
        }
        let data = JSON.parse(JSON.stringify(this.policychooseHotel));
        data.dp_id = this.userInfo.dp_id;
        data.code = code;
        data.pro_base_id = this.chooseRoom;
        data.res_id = this.chooseHotel.res_id;

        data.cancelpolicy = {
          cancelPolicyType: parseInt(data.cancelPolicyType),
        };
        if (data.cancelPolicyType == 5) {
          let dayss = parseInt(data.cancelpolicyDay);
          let hour = parseInt(data.cancelpolicyTime.split(":")[0]);
          data.cancelpolicy.policyInfo = {
            timeBefore: parseInt(dayss * 24 + (24 - hour)),
          };
        }

        function delKey(obj, ...args) {
          args.map((v) => {
            delete obj[v];
          });
          return obj;
        }

        delKey(
          data,
          "stock",
          "cancelpolicyTime",
          "cancelPolicyType",
          "cancelpolicyDay"
        );
        data.cancelpolicy = JSON.stringify(data.cancelpolicy).replace(
          /&quot;/g,
          '"'
        );

        Loading.service(options);
        this.$axios
          .editProBasePolicy(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            if (res) {
              this.policyVisible = false;
              this.HotelDetail();
            }
          })
          .catch((err) => {});
      },
      // 获取房型列表
      HotelDetail() {
        Loading.service(options);
        let data = {
          res_id: this.chooseHotel.res_id,
          rs_time: this.rs_time,
          days: this.days,
        };
        this.$axios
          .HotelDetail(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            var list = Array.isArray(res) ? res : [];
            /* 接口 success 且 data 为空数组时，原逻辑访问 res[0].remarks 会抛错进入 catch，tableData 未清空，仍显示上一酒店房型 */
            if (!list.length) {
              this.tableData = [];
              this.opened = [];
              this.weekList = [];
              return;
            }
            if (list[0] && list[0].remarks !== undefined) {
              this.chooseHotel.rb_deposit_and_prepaid = list[0].remarks;
            }
            var nextOpened = [];
            list.map((item) => {
              item.showDetail = true;
              if (item.pro_fac) {
                item.pro_fac.map((val) => {
                  if (!val.cancelpolicy) {
                    val.cancelpolicy = "";
                  }
                  if (val.stock && val.stock.length) {
                    var id = String(item.pro_base_id);
                    if (nextOpened.indexOf(id) === -1) {
                      nextOpened.push(id);
                    }
                  }
                });
              }
            });
            this.opened = nextOpened;
            this.tableData = list;
            let arr = [];
            list.forEach((item, index) => {
              if (item.pro_fac) {
                item.pro_fac.forEach((tab, num) => {
                    if (tab.stock && tab.stock.length) {
                      tab.stock.map((item) => {
                        let a = this.getReturnWeek(item.rs_time);
                        arr.push(a)
                      });
                    }
                })
              }
            })
            this.weekList = arr.splice(0,7)
          })
          .catch((err) => {
            Loading.service(options).close();
          });
      },
      /** 政策行：早餐文案（表格侧与移动端共用） */
      policyBreakfastLabel(tab) {
        if (!tab) {
          return "—";
        }
        var c = tab.breakfast_count;
        if (c == 0) return "无早";
        if (c == 1) return "单早";
        if (c == 2) return "双早";
        if (c == 3) return "三份早餐";
        if (c == 4) return "四份早餐";
        return "含早";
      },
      showRoomList() {
        this.centerDialogVisible = true;
      },
      // 获取酒店基础房型列表
      proShowBaseList() {
        if (!this.assertCanMaintain()) {
          return;
        }
        Loading.service(options);
        let data = {
          id: this.chooseHotel.show_res_id,
        };
        this.$axios
          .proShowBaseList(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            res.map((item, index) => {
              if (item.rpb_has_windows == 1) {
                item.windowsName = "有窗";
              } else if (item.rpb_has_windows == 0) {
                item.windowsName = "无窗";
              } else if (item.rpb_has_windows == 2) {
                item.windowsName = "部分有窗";
              }

              if (item.rpb_has_broadband == 1) {
                item.wifi = "有WiFi";
              } else if (item.rpb_has_broadband == 0) {
                item.wifi = "无WiFi";
              } else if (item.rpb_has_broadband == 2) {
                item.wifi = "部分有WiFi";
              }

              if (item.rpb_non_smoking == 1) {
                item.smoke = "有无烟处理";
              } else {
                item.smoke = "无无烟处理";
              }
              item.hasRoom = this.tableData.some((val) => {
                return (
                  val.show_pro_base_id == item.show_pro_base_id
                );
              });
              if (item.hasRoom) {
                res.splice(index, 1);
              }
            });
            this.baseRoomList = res;
            this.centerDialogVisible = true;
          })
          .catch((err) => {
            Loading.service(options).close();
          });
      },
      // 新增房型
      addRoom(e) {
        if (!this.assertCanMaintain()) {
          return;
        }
        if (this.ebkMobile) {
          this.addRoomConfirmRow = e;
          this.addRoomConfirmVisible = true;
          return;
        }
        this.$confirm("要新增房型吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.sendAddRoom(e);
          })
          .catch(() => {});
      },
      submitAddRoomConfirm() {
        var row = this.addRoomConfirmRow;
        this.addRoomConfirmVisible = false;
        this.addRoomConfirmRow = null;
        if (row) {
          this.sendAddRoom(row);
        }
      },
      sendAddRoom(e) {
        if (!this.assertCanMaintain()) {
          return;
        }
        let hasRoom = this.tableData.filter((item) => {
          return item.show_pro_base_id == e.show_pro_base_id;
        });
        if (hasRoom.length) {
          this.$message({
            message: "该房型已被添加",
            type: "warning",
          });
          return;
        }
        Loading.service(options);
        let data = {
          res_id: this.chooseHotel.res_id,
          show_pro_base_id: e.show_pro_base_id,
        };
        this.$axios
          .editMatchingProBase(qs.stringify(data))
          .then((res) => {
            this.centerDialogVisible = false;
            Loading.service(options).close();
            if (res) {
              this.HotelDetail();
            }
          })
          .catch((err) => {});
      },
      // 编辑房型
      editType(e) {
        this.chooseHotel = JSON.parse(JSON.stringify(e));
        this.editTypeWrapper = true;
      },
      // 验证通过即发送编辑请求
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.sendEditRoom();
          } else {
            return false;
          }
        });
      },
      //  发送编辑请求
      sendEditRoom() {
        if (!this.assertCanMaintain()) {
          return;
        }
        Loading.service(options);
        let data = JSON.parse(JSON.stringify(this.chooseHotel));
        data.dp_id = this.userInfo.dp_id;
        data.res_id = this.chooseHotel.res_id;
        delete data.pro_fac;
        this.$axios
          .editMatchingProBase(qs.stringify(data))
          .then((res) => {
            this.centerDialogVisible = false;
            Loading.service(options).close();
            if (res) {
              this.HotelDetail();
              this.editTypeWrapper = false;
            }
          })
          .catch((err) => {});
      },
      searchLog() {
        this.logPage = 1;
        this.getLog();
      },
      // 获取日志
      getLog() {
        Loading.service(options);
        let data = {
          start: (this.logPage - 1) * this.logLimit,
          limit: this.logLimit,
          page: this.logPage,
          res_id: this.chooseHotel.res_id,
          s_add_time: this.logTime[0],
          e_add_time: this.logTime[1],
        };
        this.$axios
          .getResLog(qs.stringify(data))
          .then((res) => {
            Loading.service(options).close();
            if (res) {
              this.logTotal = res.cnt;
              this.logs = res.logs;
            }
            this.logDialogVisible = true;
          })
          .catch((err) => {
            Loading.service(options).close();

          });
      },
      // 修改日志请求数量
      handleLogSizeChange(e) {
        this.logLimit = e;
        this.getLog();
      },
      // 修改日志页数
      handleLogCurrentChange(e) {
        this.logPage = e;
        this.getLog();
      },
    },
  };
</script>

<style scoped>
  .hundreds {
    width: 500px;
  }

  .title {
    color: #909399;
  }

  .con {
    color: #606266;
  }

  .week {
    width: 14.25%;
  }

  .left-w {
    width: 150px;
  }

  .table-tt {
    border-top: 1px solid #dfe5e7;
  }

  .table-bb {
    border-bottom: 1px solid #dfe5e7;
  }

  .border-ll {
    border-left: 1px solid #dfe5e7;
  }

  .border-rr {
    border-right: 1px solid #dfe5e7;
  }

  .el-date-editor /deep/ .el-range-separator {
    width: 6%;
  }

  .room-hotel-card /deep/ .el-card__header {
    padding: 12px 16px;
    border-bottom: 1px solid #ebeef5;
  }

  .room-hotel-card__hd {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    text-align: left;
  }

  .room-hotel-card__name {
    flex: 1;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    word-break: break-word;
  }

  .room-hotel-card__tag {
    flex-shrink: 0;
    margin-top: 2px;
  }

  .room-type-page--mobile .room-hotel-card__name {
    font-size: 17px;
  }

  .room-type-page--mobile .room-hotel-card /deep/ .el-card__header {
    padding: 10px 12px;
  }

  .room-type-page--mobile .room-hotel-card /deep/ .el-card__body {
    padding: 10px 12px !important;
  }

  .room-type-page--mobile .room-hotel-m__facts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 4px;
  }

  .room-type-page--mobile .room-hotel-m__fact {
    background: #f5f7fa;
    border-radius: 8px;
    padding: 10px 12px;
    min-height: 56px;
    box-sizing: border-box;
  }

  .room-type-page--mobile .room-hotel-m__fact-k {
    font-size: 12px;
    color: #909399;
    line-height: 1.3;
    margin-bottom: 4px;
  }

  .room-type-page--mobile .room-hotel-m__fact-v {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    line-height: 1.4;
    text-align: left;
    word-break: break-all;
  }

  .room-type-page--mobile .room-hotel-m__fact-v--tel {
    color: #409eff;
    text-decoration: none;
  }

  .room-type-page--mobile .room-hotel-m__sect {
    padding: 10px 0;
    border-top: 1px solid #ebeef5;
  }

  .room-type-page--mobile .room-hotel-m__sect--last {
    padding-bottom: 2px;
  }

  .room-type-page--mobile .room-hotel-m__sect-k {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
    text-align: left;
  }

  .room-type-page--mobile .room-hotel-m__sect-k i {
    font-size: 14px;
    color: #c0c4cc;
  }

  .room-type-page--mobile .room-hotel-m__sect-v {
    font-size: 14px;
    color: #303133;
    line-height: 1.55;
    text-align: left;
    word-break: break-word;
  }

  .room-type-page--mobile .room-hotel-m__input {
    width: 100%;
  }

  .room-type-page--mobile .room-hotel-m__intro {
    font-size: 13px;
    line-height: 1.6;
    text-align: left;
  }

  .room-hotel-desk__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1px;
    background: #ebeef5;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
  }

  .room-hotel-desk__item {
    display: flex;
    align-items: stretch;
    min-height: 44px;
    background: #fff;
    box-sizing: border-box;
  }

  .room-hotel-desk__item--full {
    grid-column: 1 / -1;
  }

  .room-hotel-desk__item--intro {
    align-items: flex-start;
  }

  .room-hotel-desk__item--intro .room-hotel-desk__label {
    padding-top: 14px;
  }

  .room-hotel-desk__label {
    flex: 0 0 108px;
    max-width: 108px;
    padding: 10px 12px;
    background: #fafafa;
    color: #909399;
    font-size: 13px;
    line-height: 1.4;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .room-hotel-desk__label i {
    margin-right: 4px;
    color: #c0c4cc;
  }

  .room-hotel-desk__value {
    flex: 1;
    min-width: 0;
    padding: 10px 14px;
    color: #303133;
    font-size: 13px;
    line-height: 1.5;
    word-break: break-word;
    display: flex;
    align-items: center;
  }

  .room-hotel-desk__item--intro .room-hotel-desk__value {
    align-items: flex-start;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .room-hotel-desk__value .el-input {
    width: 100%;
  }

  .room-hotel-intro {
    max-width: 100%;
    line-height: 1.65;
    word-break: break-word;
    color: #606266;
    font-size: 13px;
  }

  .room-hotel-intro--html /deep/ br,
  .room-hotel-intro--html br {
    line-height: 1.65;
  }

  .room-hotel-intro--empty {
    color: #c0c4cc;
  }

  .room-log-desk-actions {
    margin-left: auto;
  }

  .room-m-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 4px;
  }

  .room-m-policy-fields {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .room-m-control {
    width: 100%;
  }

  .room-type-page--mobile .room-m-control.el-date-editor {
    max-width: 100%;
  }

  .room-m-btn-row {
    display: flex;
    gap: 8px;
  }

  .room-m-btn-row .el-button {
    flex: 1;
    margin-left: 0;
  }

  .room-m-btn-row--2 .el-button {
    min-height: 44px;
    font-size: 14px;
  }

  .room-m-touch-btn {
    min-height: 44px;
    padding-left: 14px;
    padding-right: 14px;
    font-size: 14px;
  }

  .room-m-scroll-hint {
    font-size: 12px;
    color: #909399;
    padding: 0 4px 8px;
    line-height: 1.4;
    margin: 0;
  }

  .room-type-page--mobile .room-week-board-outer--m {
    overflow-x: hidden;
    max-width: 100%;
  }

  .room-type-page--mobile .room-week-board--m {
    min-width: 0;
    width: 100%;
    max-width: 100%;
  }

  .room-policy-head {
    min-height: 87px;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    gap: 8px 10px;
  }

  .room-policy-head__name {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
    max-width: 100%;
  }

  .room-policy-head__chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .room-policy-head__tag {
    border-radius: 6px !important;
    font-weight: 500;
  }

  .room-type-page--mobile .room-policy-head--m {
    height: auto !important;
    min-height: 72px;
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: center;
    padding: 12px 12px 12px 10px !important;
    box-sizing: border-box;
    background: #f5f7fa;
  }

  .room-type-page--mobile .room-policy-head--m .room-policy-head__name {
    font-size: 15px;
    font-weight: 600;
    width: 100%;
    padding-right: 4px;
  }

  .room-type-page--mobile .room-policy-head--m .room-policy-head__chips {
    width: 100%;
    margin-top: 2px;
  }

  .room-type-page--mobile .room-policy-head--m .room-policy-head__tag {
    padding: 0 12px !important;
    height: 28px !important;
    line-height: 26px !important;
    font-size: 13px !important;
  }

  .room-type-page--mobile .room-policy-row--m {
    flex-wrap: wrap;
    align-items: stretch;
    border-bottom: 1px solid #ebeef5;
  }

  .room-type-page--mobile .room-policy-row--m .room-policy-head {
    width: 100% !important;
    flex: 1 1 100%;
    max-width: 100%;
    border-left: 1px solid #dfe5e7;
    border-right: 1px solid #dfe5e7;
  }

  .room-type-page--mobile .room-policy-row--m .room-policy-stock-wrap {
    width: 100% !important;
    flex: 1 1 100%;
    border-left: 1px solid #dfe5e7;
    border-right: 1px solid #dfe5e7;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  .room-type-page--mobile .room-policy-stock-inner {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    width: 100% !important;
    min-width: 0 !important;
    padding: 0 2px 6px;
    box-sizing: border-box;
  }

  .room-type-page--mobile .room-policy-stock-inner .week {
    width: 100% !important;
    max-width: 100%;
    flex: none !important;
    box-sizing: border-box;
    margin: 0 !important;
    padding: 10px 8px !important;
    background: #fafbfc;
    border: 1px solid #e4e7ed !important;
    border-radius: 10px !important;
    border-left: 1px solid #e4e7ed !important;
    border-right: 1px solid #e4e7ed !important;
    border-bottom: 1px solid #e4e7ed !important;
  }

  .room-type-page--mobile .room-policy-stock-inner .week .fc-sub span {
    font-size: 11px;
    word-break: break-all;
    line-height: 1.3;
  }

  .room-type-page--mobile .room-policy-actions-col--m {
    width: 100% !important;
    flex: 1 1 100%;
    max-width: 100%;
    flex-wrap: nowrap;
    justify-content: stretch;
    gap: 8px;
    padding: 10px 8px 12px;
    box-sizing: border-box;
    border-left: 1px solid #dfe5e7;
    border-right: 1px solid #dfe5e7;
  }

  .room-type-page--mobile .room-policy-actions-col--m .room-policy-action-btn {
    flex: 1;
    margin: 0 !important;
    min-height: 44px;
    padding-left: 6px;
    padding-right: 6px;
    font-size: 13px;
  }

  .room-collapse-m {
    width: 100%;
    padding: 0;
    box-sizing: border-box;
  }

  .room-collapse-m__head {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
    position: relative;
  }

  .room-collapse-m__name {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 1.25;
    word-break: break-word;
    flex: 1;
    min-width: 0;
    text-align: center;
    padding: 0 4px;
  }

  .room-collapse-m__name--tap {
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .room-collapse-m__chev {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 30px;
    color: #409eff;
    font-size: 14px;
    border-radius: 6px;
    background: #ecf5ff;
    cursor: pointer;
    user-select: none;
  }

  .room-collapse-m__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 5px 6px;
    margin-bottom: 6px;
  }

  .room-collapse-m__cell {
    padding: 5px 6px;
    background: #f6f8fa;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-sizing: border-box;
    min-width: 0;
  }

  .room-collapse-m__cell-hd {
    display: flex;
    align-items: center;
    gap: 3px;
    margin-bottom: 2px;
  }

  .room-collapse-m__ico {
    font-size: 12px;
    color: #409eff;
    line-height: 1;
    flex-shrink: 0;
  }

  .room-collapse-m__lbl {
    font-size: 10px;
    color: #909399;
    line-height: 1.15;
  }

  .room-collapse-m__val {
    display: block;
    font-size: 11px;
    font-weight: 600;
    color: #303133;
    line-height: 1.25;
    word-break: break-word;
  }

  .room-collapse-m__foot {
    display: flex;
    gap: 6px;
    padding-top: 0;
    width: 100%;
  }

  .room-collapse-m__foot-duo {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
    min-width: 0;
  }

  .room-collapse-m__foot-duo > .room-collapse-m__btn-wrap,
  .room-collapse-m__foot-duo > .room-collapse-m__btn {
    flex: 1;
    min-width: 0;
  }

  .room-collapse-m__btn-wrap {
    display: flex;
    align-items: center;
    gap: 2px;
    min-width: 0;
  }

  .room-collapse-m__btn-wrap .room-collapse-m__btn {
    flex: 1;
    min-width: 0;
  }

  .room-collapse-m__panel-arrow {
    flex-shrink: 0;
    margin: 0;
    padding: 4px;
    font-size: 12px;
    color: #909399;
    line-height: 1;
    cursor: pointer;
    transition: transform 0.3s;
    -webkit-tap-highlight-color: transparent;
  }

  .room-collapse-m__panel-arrow.is-active {
    transform: rotate(90deg);
  }

  .room-collapse-m__foot .room-collapse-m__btn {
    flex: 1;
    margin: 0 !important;
    min-height: 32px;
    padding: 4px 6px !important;
    font-size: 12px;
  }

  .room-type-page /deep/ .el-collapse-item__header {
    height: auto !important;
    line-height: 1.45 !important;
    padding: 10px 12px !important;
    align-items: flex-start;
  }

  .room-type-page--mobile /deep/ .el-collapse-item__header {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px 10px !important;
  }

  /* 移动端：折叠面板箭头挪到底部「查询产品」旁，隐藏头部内置箭头避免重复 */
  .room-type-page--mobile /deep/ .el-collapse-item__header > .el-collapse-item__arrow {
    display: none !important;
  }

  .room-type-page--mobile /deep/ .el-collapse-item__header > .room-collapse-m {
    flex: 1;
    min-width: 0;
  }

  .room-stock-switch-hit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    margin: -8px -4px;
    padding: 8px;
    box-sizing: border-box;
  }

  .room-m-log {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .room-m-log-btn {
    width: 100%;
    margin-left: 0;
  }

  .room-m-log-btn.room-m-touch-btn {
    width: 100%;
  }

  .room-m-addbase-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    box-sizing: border-box;
    margin-top: 4px;
  }

  .room-m-addbase-empty {
    text-align: center;
    padding: 24px 12px;
    font-size: 13px;
    color: #909399;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px dashed #e4e7ed;
  }

  .room-m-addbase-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
  }

  .room-m-addbase-card__title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.35;
    margin-bottom: 10px;
    word-break: break-word;
  }

  .room-m-addbase-card__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 10px;
    margin-bottom: 12px;
  }

  .room-m-addbase-cell {
    padding: 8px 10px;
    background: #f6f8fa;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-sizing: border-box;
    min-width: 0;
  }

  .room-m-addbase-cell--full {
    grid-column: 1 / -1;
  }

  .room-m-addbase-cell__lbl {
    display: block;
    font-size: 11px;
    color: #909399;
    line-height: 1.2;
    margin-bottom: 4px;
  }

  .room-m-addbase-cell__val {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #303133;
    line-height: 1.3;
    word-break: break-word;
  }

  .room-m-addbase-card__btn {
    width: 100%;
    margin: 0 !important;
  }

  .room-type-page--mobile .room-collapse-title-row {
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .room-type-page--mobile .room-collapse-name-row {
    flex-wrap: wrap;
    align-items: flex-start;
    min-width: 0;
    flex: 1 1 auto;
  }

  .room-type-page--mobile .room-type-name-text {
    flex: 1;
    min-width: 0;
    word-break: break-word;
  }

  .room-type-page--mobile .room-collapse-meta {
    flex: 1 1 100%;
    margin-left: 0 !important;
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 12px;
  }

  .room-type-page--mobile .room-collapse-meta > span {
    margin-left: 0 !important;
  }

  .room-type-page--mobile .room-collapse-ops:not(.room-collapse-ops--m) {
    flex-shrink: 0;
    align-self: flex-start;
    padding-top: 2px;
    padding-left: 6px;
  }

  .room-type-page--mobile .room-collapse-ico {
    display: inline-block;
    padding: 10px;
    font-size: 18px !important;
    box-sizing: content-box;
  }

  .room-type-page--mobile .room-policy-inline-row--m {
    flex-direction: column;
  }

  .room-type-page--mobile .room-policy-inline-row--m .el-form-item {
    width: 100%;
    margin-right: 0;
  }

  .room-type-page--mobile .hundreds {
    width: 100% !important;
    max-width: 100%;
  }

  .room-type-page--mobile .room-policy-form {
    width: 100%;
  }

  .room-type-page--mobile .demo-policychooseHotel .el-form-item {
    margin-bottom: 14px;
  }

  .room-m-log-cards {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;
  }

  .room-m-log-empty {
    text-align: center;
    padding: 20px 12px;
    font-size: 13px;
    color: #909399;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px dashed #e4e7ed;
  }

  .room-m-log-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 12px 14px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
  }

  .room-m-log-card__hd {
    margin-bottom: 10px;
  }

  .room-m-log-card__tag {
    max-width: 100%;
    white-space: normal;
    height: auto !important;
    line-height: 1.35 !important;
    padding: 4px 8px !important;
    word-break: break-word;
  }

  .room-m-log-card__row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 6px;
    font-size: 13px;
    line-height: 1.45;
  }

  .room-m-log-card__row:last-of-type {
    margin-bottom: 0;
  }

  .room-m-log-card__k {
    flex-shrink: 0;
    width: 72px;
    font-size: 12px;
    color: #909399;
  }

  .room-m-log-card__k--block {
    width: auto;
    margin-bottom: 4px;
  }

  .room-m-log-card__v {
    flex: 1;
    min-width: 0;
    color: #303133;
    font-weight: 500;
    word-break: break-word;
  }

  .room-m-log-card__body {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f0f2f5;
  }

  .room-m-log-card__text {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    word-break: break-word;
    white-space: pre-wrap;
  }

  .room-type-page--mobile .room-log-pager--m /deep/ .el-pagination {
    padding: 8px 0 4px;
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 6px 4px;
    max-width: 100%;
  }

  .room-type-page--mobile .room-log-pager--m /deep/ .el-pagination > * {
    margin: 0 !important;
  }

  .room-type-page--mobile .room-log-block .el-pagination {
    padding: 4px 0;
  }

  .room-type-page--mobile .room-log-block .el-pagination .btn-prev,
  .room-type-page--mobile .room-log-block .el-pagination .btn-next,
  .room-type-page--mobile .room-log-block .el-pager li {
    min-width: 32px;
    min-height: 30px;
    line-height: 30px;
  }
</style>

<!-- 弹窗挂到 body，需全局类名才能命中 -->
<style>
  .room-stock-switch-hit--readonly {
    opacity: 0.55;
    cursor: not-allowed;
    pointer-events: none;
  }

  .room-collapse-ico--disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .ebk-room-dialog--mobile .el-dialog__header {
    padding: 14px 16px 8px;
  }

  .ebk-room-dialog--mobile .el-dialog__title {
    font-size: 16px;
    line-height: 1.4;
    word-break: break-word;
  }

  .ebk-room-dialog--mobile .el-dialog__body {
    padding: 12px 16px 16px;
    max-height: calc(100vh - 130px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ebk-room-dialog--mobile .el-dialog__body .el-button {
    min-height: 44px;
    padding-left: 16px;
    padding-right: 16px;
    font-size: 14px;
  }

  .ebk-room-dialog--mobile .el-dialog__body .el-button + .el-button {
    margin-left: 0;
  }

  .ebk-room-dialog--mobile .el-dialog__body .el-button--text {
    min-height: 44px;
    line-height: 1.2;
  }

  .ebk-room-dialog--mobile .ebk-room-table-action {
    min-height: 40px;
    width: 100%;
    max-width: 112px;
  }

  .ebk-room-dialog--mobile .room-dialog-form-actions .el-form-item__content {
    margin-left: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }

  .ebk-room-dialog--mobile .room-dialog-form-actions .el-button {
    width: 100%;
    margin: 0 !important;
  }

  .ebk-room-dialog--mobile .el-tabs__header {
    margin-bottom: 12px;
  }

  .ebk-room-dialog--mobile .el-tabs__nav-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ebk-room-dialog--mobile .el-tabs__item {
    padding: 0 14px;
    height: 42px;
    line-height: 42px;
    font-size: 14px;
  }

  .ebk-room-dialog--mobile .el-tabs--card > .el-tabs__header .el-tabs__item {
    min-height: 42px;
  }

  .ebk-room-dialog--mobile .el-checkbox {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .ebk-room-dialog--mobile .el-checkbox__label {
    font-size: 14px;
    padding-left: 8px;
  }

  .ebk-room-dialog--mobile .el-radio {
    margin-right:16px;
    margin-bottom: 8px;
  }

  .ebk-room-dialog--mobile .el-radio__label {
    font-size: 14px;
    padding-left: 8px;
  }

  .ebk-room-dialog--mobile .demo-chooseHotel .el-form-item__content .el-select,
  .ebk-room-dialog--mobile .demo-chooseHotel .el-form-item__content .el-date-editor {
    width: 100% !important;
    max-width: 100%;
  }

  .ebk-room-dialog--mobile .hundred {
    width: 100% !important;
  }

  .ebk-room-dialog--mobile .hundreds {
    width: 100% !important;
    max-width: 100%;
  }

  .ebk-room-dialog--mobile .room-policy-form .el-form-item .el-select,
  .ebk-room-dialog--mobile .room-policy-form .el-form-item .el-input,
  .ebk-room-dialog--mobile .room-policy-form .el-form-item .el-input-number {
    width: 100% !important;
    max-width: 100%;
  }

  /* 新增房型 — 二次确认（独立 dialog） */
  .room-add-confirm-dialog.el-dialog {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.16);
  }
  .room-add-confirm-dialog .el-dialog__header {
    padding: 18px 20px 10px;
    border-bottom: 1px solid #eef0f4;
  }
  .room-add-confirm-dialog .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    color: #303133;
    line-height: 1.35;
  }
  .room-add-confirm-dialog .el-dialog__headerbtn {
    top: 12px;
    right: 12px;
    font-size: 18px;
  }
  .room-add-confirm-dialog .el-dialog__body {
    padding: 18px 20px 12px;
    box-sizing: border-box;
  }
  .room-add-confirm-dialog .room-add-confirm-body {
    display: flex;
    align-items: flex-start;
    gap: 14px;
  }
  .room-add-confirm-dialog .room-add-confirm-ico {
    flex-shrink: 0;
    font-size: 36px;
    color: #e6a23c;
    line-height: 1;
    margin-top: 2px;
  }
  .room-add-confirm-dialog .room-add-confirm-copy {
    flex: 1;
    min-width: 0;
  }
  .room-add-confirm-dialog .room-add-confirm-text {
    margin: 0 0 10px;
    font-size: 16px;
    line-height: 1.55;
    color: #303133;
    font-weight: 500;
    word-break: break-word;
  }
  .room-add-confirm-dialog .room-add-confirm-sub {
    margin: 0;
    padding: 10px 12px;
    font-size: 14px;
    line-height: 1.45;
    color: #606266;
    word-break: break-word;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px solid #ebeef5;
  }
  .room-add-confirm-dialog .el-dialog__footer {
    padding: 10px 20px 18px;
    border-top: 1px solid #eef0f4;
    box-sizing: border-box;
  }
  .room-add-confirm-dialog .room-add-confirm-footer {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 12px;
  }
  .room-add-confirm-dialog .room-add-confirm-footer .el-button {
    min-width: 96px;
  }

  .room-add-confirm-dialog--mobile.el-dialog {
    margin-top: 12vh !important;
    max-width: min(400px, calc(100vw - 24px));
  }
  .el-dialog.room-add-confirm-dialog.room-add-confirm-dialog--mobile
    .el-dialog__header {
    padding: 16px 40px 8px 16px;
  }
  .el-dialog.room-add-confirm-dialog.room-add-confirm-dialog--mobile
    .el-dialog__body {
    padding: 12px 16px 8px;
  }
  .el-dialog.room-add-confirm-dialog.room-add-confirm-dialog--mobile
    .room-add-confirm-ico {
    font-size: 32px;
  }
  .el-dialog.room-add-confirm-dialog.room-add-confirm-dialog--mobile
    .el-dialog__footer {
    padding: 12px 16px;
    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px));
  }
  .el-dialog.room-add-confirm-dialog.room-add-confirm-dialog--mobile
    .room-add-confirm-footer {
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
  .el-dialog.room-add-confirm-dialog.room-add-confirm-dialog--mobile
    .room-add-confirm-footer
    .el-button {
    width: 100%;
    margin: 0 !important;
    min-height: 46px;
    font-size: 15px;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/roomType.vue